mtl.alloy.factory['smooth-scroll'] = (function($, app, util) {
    'use strict';

    return function(element, options) {

        $(element).on('click', smoothScroll);

        //On page load, smooth scroll to panel
        var hash = window.location.hash.replace('panel-', '');
        if (hash) {
            $('a[href="'+hash+'"]').click();
        }

    };

    function smoothScroll(e)
    {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - $('.layout-header').height()
        }, 900, 'swing', function () {
            window.location.hash = 'panel-' + target.replace('#', '');;
        });
    }

}(jQuery, app, util));
